/**
 * Utility function, creates AoPS.Contest if it doesn't exist already.
 */

AoPS.Utils.initKeyChain(AoPS, "Contests", "Models");

// Note: Extends from contests_common_models.js, which has the declaration for
//   many of the raw types.
AoPS.Contests.Models = (function (Models) {
	Models.Master = Models.GenericMaster.extend({
		initialize: function () {
			this.addOrUpdateContestPortalHost(
				AoPS.bootstrap_data.contest_portal_hosts || []
			);
			this.addOrUpdateContestPortalInvitation(
				AoPS.bootstrap_data.contest_portal_invitations || []
			);
			this.addOrUpdateContestPortalUser(
				AoPS.bootstrap_data.contest_portal_users || []
			);
			this.addOrUpdateContestPortalRequestedUser(
				AoPS.bootstrap_data.contest_portal_requested_users || []
			);

			_.each(
				[
					"isProduction",
					"registrations",
					"root_contest_id",
					"is_coach",
					"is_limited",
					"contest_portal_registration_forms",
					"contest_terms",
					"host_name",
					"host_id",
					"coach_name",
					"coach_email",
					"page_title",
					"contest_events",
					"events",
					"registered_hashes_individual",
					"registered_hashes_team",
					"active_hashes_individual",
					"active_hashes_team",
					"completed_hashes_individual",
					"completed_hashes_team",
					"contest_individual_entries",
					"contest_team_entries",
					"academy_url",
				],
				_.bind(function (key) {
					this.set(key, AoPS.bootstrap_data[key]);
				}, this)
			);

			// FAQs objects
			if (AoPS.bootstrap_data.faqs !== undefined) {
				this.set("faqs", AoPS.bootstrap_data.faqs);
			}

			// FAQs partial
			if (AoPS.bootstrap_data.faqs_partial !== undefined) {
				this.set("faqs_partial", AoPS.bootstrap_data.faqs_partial);
			}

			this.addOrUpdateContestFlavor(AoPS.bootstrap_data.contest_flavors || []);
			this.addOrUpdateContest(AoPS.bootstrap_data.contests || []);
			this.addOrUpdateContestWindow(AoPS.bootstrap_data.contest_windows || []);
			this.addOrUpdateContestCms(AoPS.bootstrap_data.contest_cms || []);
			this.addOrUpdateContestTeam(AoPS.bootstrap_data.contest_teams || []);

			this.set(
				"rootContest",
				this.getWhere("contests", {
					contest_id: this.get("root_contest_id"),
				})
			);
		},
		getCmsHelper: function (files, template_selector, vars) {
			var output = null;
			_.each(
				_.isArray(files) ? files : [files],
				_.bind(function (file) {
					if (_.isNull(output)) {
						var cms = this.getWhere("contest_cms", {file: file});
						if (cms) {
							output = cms.getHbOutput(template_selector, vars) || null;
						}
					}
				}, this)
			);
			return output;
		},
		getStudentUploadData: function (input, success, failure) {
			AoPS.Contests.Utils.ajax_portal_runner.run(
				"get-student-upload-data",
				input,
				_.bind(function (ok, data) {
					if (ok) {
						if (_.isFunction(success)) {
							success(data.response);
						}
					} else {
						AoPS.Contests.Utils.CreateModalAlert(
							$("<div />")
								.css("max-width", "480px")
								.text("Error: " + data.error_msg)
						);
						if (_.isFunction(failure)) {
							failure(data.response);
						}
					}
				}, this)
			);
		},
	});

	Models.Contest = Models.Contest.extend({
		fetch: function () {
			this.set(
				"flavor",
				this.get("master").getWhere("contest_flavors", {
					flavor_hash: this.get("flavor_hash"),
				})
			);
		},
		computeContestPortalUser: function () {
			return this.get("master").getWhere("contest_portal_users", {
				contest_id: this.get("contest_id"),
			});
		},
		getCmsTemplate: function (template_selector, vars) {
			var cpu = this.computeContestPortalUser();
			var parentContest = this.computeParentContest();
			var templates = [];

			if (!cpu && parentContest) {
				cpu = parentContest.computeContestPortalUser();
			}

			if (cpu) {
				templates.push(
					"type_" +
						cpu.get("user_type") +
						"_contest_" +
						this.get("contest_cms_hash")
				);
			}
			templates.push("contest_" + this.get("contest_cms_hash"));

			if (parentContest) {
				if (cpu) {
					templates.push(
						"type_" +
							cpu.get("user_type") +
							"_contest_" +
							parentContest.get("contest_cms_hash")
					);
				}
				templates.push("contest_" + parentContest.get("contest_cms_hash"));
			}

			if (this.get("flavor")) {
				if (cpu) {
					templates.push(
						"type_" +
							cpu.get("user_type") +
							"_flavor_" +
							this.get("flavor").get("flavor_cms_hash")
					);
				}
				templates.push("flavor_" + this.get("flavor").get("flavor_cms_hash"));
			}

			if (parentContest && parentContest.get("flavor")) {
				if (cpu) {
					templates.push(
						"type_" +
							cpu.get("user_type") +
							"_flavor_" +
							parentContest.get("flavor").get("flavor_cms_hash")
					);
				}
				templates.push(
					"flavor_" + parentContest.get("flavor").get("flavor_cms_hash")
				);
			}

			if (cpu) {
				templates.push("type_" + cpu.get("user_type") + "_flavor_default");
			}

			templates.push("flavor_default");

			return this.get("master").getCmsHelper(
				_.uniq(templates),
				template_selector,
				vars
			);
		},
		getProblemType: function (type, success = () => {}) {
			// note that this goes to ajax_landing.php
			AoPS.Contests.Utils.ajax_runner.run(
				"get_problem_type",
				{type: type},
				_.bind(function (ok, data) {
					if (ok) {
						success(data.response.format_data);
					} else {
						if (data.error_msg) {
							setTimeout(function () {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />").css("max-width", "480px").text(data.error_msg)
								);
							}, 100);
						}
					}
				}, this)
			);
		},
		computeWindow: function () {
			var registrations = this.get("master").get("registrations");
			var current_registration = _.findWhere(registrations, {
				contest_id: this.get("contest_id"),
			});
			if (!current_registration) {
				return null;
			}
			var window_id = current_registration["contest_window_id"];
			var window =
				this.get("master")
					.get("contest_windows")
					.find(
						_.bind(function (item) {
							return (
								item.get("contest_window_id") === window_id &&
								item.get("can_display") &&
								!item.get("deleted_at")
							);
						}, this)
					) ||
				this.get("master")
					.get("contest_windows")
					.find(
						_.bind(function (item) {
							return (
								item.get("contest_window_id") === window_id &&
								!item.get("deleted_at")
							);
						}, this)
					);
			return window;
		},
		getTerms: function () {
			return (
				(
					_.findWhere(this.get("master").get("contest_terms"), {
						contest_id: this.get("parent_contest_id") || this.get("contest_id"),
					}) || {}
				).terms || {}
			);
		},
		generateOfficialStatus: function (entry) {
			var terms = this.getTerms();
			var $official_status = $("<p />");
			var $current_status = $("<span />")
				.css("font-weight", "bold")
				.css("color", "#ff7a0c"); // basically orange
			var db_format = "YYYY-MM-DD HH:mm:ss";
			var output_format = "MM/DD, HH:mm";

			if (entry.data && entry.data.flow && entry.data.flow.current) {
				var items = entry.data.flow.items;
				var i_curr = items.findIndex(
					(item) => item.id === entry.data.flow.current
				);
				var i_first = items.findIndex((item) => item.contest_start === true);
				var i_last = items.findIndex((item) => item.contest_end === true);

				// needed for legacy contest flows like AMC 8 that didn't have contest_start and contest_end attributes
				// but this doesn't work for multi-stage contests like MATHCOUNTS, so here we are
				if (i_first === -1) {
					i_first = entry.data.flow.items.findIndex(
						(item) => !item.id.includes("before") && !item.id.includes("after")
					);
				}

				if (i_last === -1) {
					var reversed_items = items.slice().reverse(); // slice gives us a new copy of the array
					i_last = reversed_items.findIndex(
						(item) => !item.id.includes("before") && !item.id.includes("after")
					);
					i_last = items.length - i_last - 1; // recalculation because we started counting from the end
				}

				if (i_curr < i_first) {
					// pre-competition
					$current_status.html(
						("Currently in Pre-" + terms.contest.uc + " Steps").replace(
							/ /g,
							"&nbsp;"
						)
					);
				} else {
					// mid-competition, post-competition, or completed
					var started_at = moment(items[i_first].start, db_format).format(
						output_format
					);
					started_at = ("Started: " + started_at + " ET").replace(
						/ /g,
						"&nbsp;"
					);
					$official_status
						.append($("<span />").html(started_at))
						.append("<br>");

					if (i_first <= i_curr && i_curr <= i_last) {
						// mid-competition
						$current_status.html("Currently in Progress");
					} else {
						// post-competition or completed
						var end =
							items[i_last].end > items[i_last].deadline
								? items[i_last].deadline
								: items[i_last].end;
						var ended_at = moment(end, db_format).format(output_format);
						ended_at = ("Ended: " + ended_at + " ET").replace(/ /g, "&nbsp;");
						$official_status
							.append($("<span />").html(ended_at))
							.append("<br>");

						// (i_last < i_curr) is always true by this point

						// if not on last index
						if (i_curr < items.length - 1) {
							// post-competition
							$current_status.html(
								("Currently in Post-" + terms.contest.uc + " Steps").replace(
									/ /g,
									"&nbsp;"
								)
							);
						} else {
							// completed
							$current_status
								.css("color", "green")
								.html(terms.contest.uc + "&nbsp;Submitted");
						}
					}
				}

				$official_status.append($current_status);
			}

			return $official_status;
		},
		export: function () {
			var cpu = this.computeContestPortalUser();
			var cpu_host = cpu
				? this.get("master").getWhere("contest_portal_hosts", {
						portal_host_id: cpu.get("host_id"),
				  })
				: null;
			var parentContest = this.computeParentContest();
			var childrenContests = this.computeChildrenContests();
			var output = {
				today: AoPS.bootstrap_data.today,
				page_title: this.get("master").get("page_title"),
				contest_cms_hash: this.get("contest_cms_hash"),
				contest_general_hash: this.get("contest_general_hash"),
				contest_crumb_name: this.get("contest_crumb_name"),
				contest_hash: this.get("contest_hash"),
				root_contest_hash: (parentContest || this).get("contest_hash"),
				contest_id: this.get("contest_id"),
				contest_internal_name: this.get("contest_internal_name"),
				contest_logo: this.get("contest_logo"),
				secondary_logo: this.get("secondary_logo"),
				alternate_logo: this.get("alternate_logo"),
				contest_data: _.extend({}, this.get("data")),
				contest_name: this.get("contest_name"),
				contest_short_name: this.get("contest_short_name"),
				contest_portal_name: parentContest
					? parentContest.get("contest_portal_name") ||
					  parentContest.get("contest_short_name")
					: this.get("contest_portal_name") || this.get("contest_short_name"),
				contest_home_url:
					"/contests/" + (parentContest || this).get("contest_hash") + "",
				contest_portal_url:
					"/contests/" +
					(parentContest || this).get("contest_hash") +
					"/portal",
				contest_portal_route:
					(parentContest || this).get("contest_hash") + "/portal",
				contest_registration_id: this.get("contest_registration_id"),
				flavor: _.extend({}, (this.get("flavor") || {}).attributes),
				window: _.extend({}, (this.computeWindow() || {}).attributes),
				portal_user: _.extend({}, (cpu || {}).attributes),
				portal_host: _.extend({}, (cpu_host || {}).attributes),
				portal_registration_form: null,
				children: _.reduce(
					childrenContests,
					_.bind(function (carry, contest) {
						var exported = contest.export();
						if (exported.portal_user && exported.portal_user.portal_user_id) {
							carry.push(exported);
						}
						return carry;
					}, this),
					[]
				),
				standalone: this.isStandalone(),
				completed: this.isCompleted(),
				completion_date: this.getCompletionDateIndividual(),
				session: AoPS.session,
				terms: this.getTerms(),
			};
			var match_academy = output.contest_hash.match(/acadproblemsolvers.*/);
			var match_academy_championship = output.contest_hash.match(
				/acadproblemsolvers-championship.*/
			);

			output["is_academy"] = match_academy ? true : false;
			output["is_academy_championship"] = match_academy_championship
				? true
				: false;

			if (match_academy_championship) {
				// Get the name of the contest level
				output["academy_contest_level"] = output.contest_name.replace(
					"Problem Solvers Championship - ",
					""
				);
			}

			var registrationForm =
				_.findWhere(
					this.get("master").get("contest_portal_registration_forms") || [],
					{contest_id: this.get("contest_id")}
				) || {};
			var user_data = (output.portal_user || {}).data || {};

			output[
				"contest_hash_is_" + this.get("contest_hash").replace(/[^a-z0-9]+/, "_")
			] = true;

			if (this.get("flavor")) {
				output[
					"flavor_is_" +
						this.get("flavor")
							.get("flavor_hash")
							.replace(/[^a-z0-9]+/, "_")
				] = true;
			}

			if (cpu_host) {
				output["host_is_" + cpu_host.get("host_type")] = true;
			}

			if (cpu && !cpu.get("registered_at")) {
				// Fetch compatible fields from existing registrations.
				_.each(
					parentContest
						? parentContest.computeChildrenContests()
						: childrenContests,
					_.bind(function (contest) {
						if (contest.get("contest_id") !== this.get("contest_id")) {
							var child_cpu = contest.computeContestPortalUser();
							if (child_cpu && child_cpu.get("registered_at")) {
								_.extend(user_data, child_cpu.get("data"));
							}
						}
					}, this)
				);
			}

			if (_.isArray(registrationForm.form)) {
				output.portal_registration_form =
					AoPS.Contests.Utils.processRegistrationForm(
						registrationForm.form,
						user_data
					);
			}

			if (output.portal_user.user_type === "coach") {
				// For T64370: Coach Uploads
				if (
					output.window.official_individual_contest_has_started &&
					output.contest_data.coach_can_upload_until
				) {
					output.coach_show_upload = true;
					output.coach_can_upload =
						AoPS.bd.current_date_time <
						output.contest_data.coach_can_upload_until;
				}

				output.invitations = _.sortBy(
					this.get("master")
						.get("contest_portal_invitations")
						.map(
							_.bind(function (invitation) {
								var contest = this.get("master").getWhere("contests", {
									contest_id: invitation.get("contest_id"),
								});
								var host = this.get("master").getWhere("contest_portal_hosts", {
									portal_host_id: invitation.get("host_id"),
								});
								var contest_individual_entries = this.get("master").get(
									"contest_individual_entries"
								);
								var contest_model = this.getContestModelByHash(
									invitation.get("contest_hash")
								);
								var prev_contest_model;
								if (contest_model.get("succeeds")) {
									prev_contest_model = this.getContestModelByHash(
										contest_model.get("succeeds")
									);
								}
								var lock_proctored_by_coach = contest_model
									? contest_model.hasEnded()
									: true;

								var invitation_output = {
									contest_id: invitation.get("contest_id"),
									invitation_id: invitation.get("portal_invitation_id"),
									contest_name: contest
										? contest.get("contest_name")
										: "Unknown",
									contest_short_name: contest
										? contest.get("contest_short_name")
										: "Unknown",
									contest_general_hash: contest
										? contest.get("contest_general_hash")
										: "Unknown",
									contest_crumb_name: contest
										? contest.get("contest_crumb_name")
										: "Unknown",
									flavor: _.extend(
										{},
										(contest.get("flavor") || {}).attributes
									),
									host_name: host ? host.get("name") : "Unknown",
									host_id: invitation.get("host_id"),
									host_needs_coppa: host && !host.get("allow_limited"),
									needs_coppa:
										host &&
										!host.get("allow_limited") &&
										_.filter(
											invitation.get("students") || [],
											function (student) {
												return !student.is_full_user;
											}
										).length > 1,
									num_users_accepted: invitation.get("num_users_accepted"),
									num_users_accepted_is_plural:
										invitation.get("num_users_accepted") !== 1,
									num_users_total: invitation.get("num_users_total"),
									num_users_total_is_plural:
										invitation.get("num_users_total") !== 1,
									num_users_remain:
										invitation.get("num_users_total") -
										invitation.get("num_users_accepted"),
									num_users_remain_is_plural:
										invitation.get("num_users_total") -
											invitation.get("num_users_accepted") !==
										1,
									num_official_accepted: invitation.get(
										"num_official_accepted"
									),
									num_official_accepted_is_plural:
										invitation.get("num_official_accepted") !== 1,
									num_official_total: invitation.get("num_official_total"),
									num_official_total_is_plural:
										invitation.get("num_official_total") !== 1,
									num_official_remain:
										invitation.get("num_official_total") -
										invitation.get("num_official_accepted"),
									num_official_remain_is_plural:
										invitation.get("num_official_total") -
											invitation.get("num_official_accepted") !==
										1,
									url:
										AoPS.protected_url +
										"contests/accept/" +
										invitation.get("hash"),
									students: _.map(
										invitation.get("students") || [],
										_.bind(function (student) {
											var student_obj = {};
											var entries = _.where(contest_individual_entries, {
												user_id: student.user_id.toString(),
											});
											var name, entry, $official_status; // because I can't use the "let" keyword lol
											if (output.contest_hash === "mathcounts") {
												for (entry of entries) {
													try {
														entry.data = JSON.parse(entry.json_object_data);
													} catch (e) {
														console.error(e);
														continue;
													}
													name = entry.contest_general_hash;

													// assumes show_review_at is after contest end
													if (
														!_.isNull(entry.score) &&
														entry.show_review === "1"
													) {
														student_obj[name + "_completed"] = true;
														student_obj[name + "_score"] = entry.score;
														student_obj[name + "_link"] =
															"/contests/" +
															entry.contest_hash +
															"/review/" +
															student.username;
														// remove incomplete status T54675
														// } else if (
														// 	entry.contest_has_ended === "1" &&
														// 	_.isNull(entry.score)
														// ) {
														// 	// no score when contest ended means incomplete
														// 	student_obj[name + "_incomplete"] = true;
													} else if (!entry.contest_hash.includes("practice")) {
														$official_status =
															this.generateOfficialStatus(entry);
														student_obj[name + "_official_status"] = $("<p />")
															.html($official_status)
															.prop("outerHTML");
													}
												}

												student_obj.has_qualified_for_invitational =
													student.data.has_qualified_for_invitational;
												student_obj.chapter_rank = student.data.chapter_rank;
												student_obj.max_chapter_rank =
													student.data.max_chapter_rank;

												student_obj.has_qualified_for_state =
													student.data.has_qualified_for_state;
												student_obj.invitational_chapter_rank =
													student.data.invitational_chapter_rank;
												student_obj.invitational_state_rank =
													student.data.invitational_state_rank;
												student_obj.max_invitational_chapter_rank =
													student.data.max_invitational_chapter_rank;
												student_obj.max_invitational_state_rank =
													student.data.max_invitational_state_rank;

												student_obj.has_qualified_for_national =
													student.data.has_qualified_for_national;
												student_obj.state_rank = student.data.state_rank;
												student_obj.max_state_rank =
													student.data.max_state_rank;

												student_obj.national_rank = student.data.national_rank;
											} else if (output.contest_hash === "amc") {
												var contest_ids = [
													contest_model.get("contest_id").toString(),
													prev_contest_model
														? prev_contest_model.get("contest_id").toString()
														: null,
												];
												entries = _.filter(entries, function (e) {
													return contest_ids.includes(e.contest_id);
												});
												for (entry of entries) {
													try {
														entry.data = JSON.parse(entry.json_object_data);
													} catch (e) {
														console.error(e);
														continue;
													}
													if (!entry.contest_hash.includes("practice")) {
														$official_status =
															this.generateOfficialStatus(entry);
														student_obj["official_status"] = $("<p />")
															.html($official_status)
															.prop("outerHTML");
													} else {
														name = "practice";
														student_obj[name + "_completed"] = true;
														student_obj[name + "_score"] = entry.score;
														student_obj[name + "_link"] =
															"/contests/" +
															entry.contest_hash +
															"/review/" +
															student.username;
													}
												}
											}

											return _.extend(student_obj, {
												user_id: student.user_id,
												username: student.username,
												name: student.name,
												email: student.email,
												registered_at: student.registered_at,
												upgrade_needed:
													!student.is_full_user && !student.host_allows_limited,
												proctored_by_coach: student.proctored_by_coach,
												lock_proctored_by_coach: lock_proctored_by_coach,
												is_official: student.is_official,
												is_full_user: student.is_full_user,
											});
										}, this)
									),
								};

								// sort students alphabetically by first name
								invitation_output.students.sort(function (s1, s2) {
									if (s1.name === null) {
										return -1;
									}
									if (s2.name === null) {
										return 1;
									}
									var name1 = s1.name.toLowerCase().trim();
									var name2 = s2.name.toLowerCase().trim();
									if (name1 < name2) {
										return -1;
									}
									if (name1 > name2) {
										return 1;
									}
									return 0;
								});

								if (contest.get("flavor")) {
									invitation_output[
										"flavor_is_" + contest.get("flavor").get("flavor_hash")
									] = true;
								}

								if (host) {
									invitation_output["host_is_" + host.get("host_type")] = true;
								}

								if ((output.flavor || {}).has_team) {
									var team_index = 0;

									invitation_output.team_slots = _.range(
										1,
										1 + output.flavor.max_team_size
									);
									invitation_output.teams = _.map(
										this.get("master")
											.get("contest_teams")
											.filter(function (team) {
												return (
													team.get("contest_id") ===
														invitation.get("parent_contest_id") &&
													team.get("host_id") === invitation.get("host_id") &&
													!team.get("deleted_at")
												);
											}),
										_.bind(function (team) {
											var members = _.reduce(
												team.get("data").members || [],
												_.bind(function (carry, item) {
													var found = _.findWhere(invitation_output.students, {
														user_id: item.user_id,
													});
													if (found) {
														carry.push(found);
													}
													return carry;
												}, this),
												[]
											);
											var padding = [];

											for (
												var i = members.length;
												i < output.flavor.max_team_size;
												i++
											) {
												padding.push(null);
											}

											var entries = _.where(
												this.get("master").get("contest_team_entries"),
												{parent_team_id: team.get("contest_team_id").toString()}
											);
											var team_obj = {};
											if (output.contest_hash === "mathcounts") {
												// this structure works for contests with only one invitation but with multiple practice contests
												for (var entry of entries) {
													var name = entry.contest_general_hash;
													team_obj[name + "_completed"] = true;
													team_obj[name + "_score"] = entry.score;
													team_obj[name + "_link"] =
														"/contests/" +
														entry.contest_hash +
														"/review/" +
														team.get("team_leader_username");
												}
											}

											team_index++;
											return _.extend(team_obj, {
												team_id: team.get("contest_team_id"),
												index: team_index,
												members: members,
												slots: []
													.concat(members, padding)
													.slice(0, output.flavor.max_team_size),
											});
										}, this)
									);
								}

								// T51734: Show Associated Practice Contest If Open
								_.each(
									(
										_.findWhere((this.get("children") || {}).items || [], {
											id: invitation.get("contest_id"),
										}) || {}
									).include || [],
									_.bind(function (subcontestId) {
										var subcontest = this.get("master").getWhere("contests", {
											contest_id: subcontestId,
										});

										if (
											subcontest &&
											(
												this.get("master").get(
													"registered_hashes_individual"
												) || []
											).indexOf(subcontest.get("contest_hash")) >= 0
										) {
											var subcontestWindow = subcontest.computeWindow();
											if (
												subcontestWindow &&
												subcontestWindow.get("contest_can_access")
											) {
												var showReviewAt = subcontestWindow.get(
													"show_review_at"
												)
													? moment(subcontestWindow.get("show_review_at"))
													: null;
												invitation_output.registered_subcontests = _.uniq(
													(
														invitation_output.registered_subcontests || []
													).concat([
														{
															contest_id: subcontest.get("contest_id"),
															contest_name: subcontest.get("contest_name"),
															contest_hash: subcontest.get("contest_hash"),
															completed_at: (this.get("master").get(
																"completed_hashes_individual"
															) || {})[subcontest.get("contest_hash")],
															can_review: subcontestWindow.get(
																"show_review_can_access"
															),
															show_review_date: showReviewAt
																? showReviewAt.format("MMMM Do")
																: null,
															show_review_time: showReviewAt
																? showReviewAt.format("H:mm a")
																: null,
														},
													])
												);
											}
										}
									}, this)
								);

								return invitation_output;
							}, this)
						),
					"contest_id"
				);

				output.needs_coppa =
					_.filter(output.invitations, function (invitation) {
						return invitation.needs_coppa;
					}).length > 0;

				_.each(
					[
						"contest_name",
						"contest_short_name",
						"contest_id",
						"host_name",
						"host_id",
					],
					function (key) {
						output["all_" + key] = _.uniq(_.pluck(output.invitations, key));
						output["all_" + key + "_joined"] =
							AoPS.Contests.Utils.ArrayToCommaSeparatedString(
								output["all_" + key],
								{oxford: true}
							);
						output["has_multiple_" + key] = output["all_" + key].length !== 1;
					}
				);
			}

			if (!parentContest) {
				var otherContests = this.get("master")
					.get("contests")
					.filter(
						_.bind(function (contest) {
							return (
								contest.get("contest_id") !==
									this.get("master").get("rootContest").get("contest_id") &&
								contest.get("parent_contest_id") !==
									this.get("master").get("rootContest").get("contest_id")
							);
						}, this)
					);
				output.other_contests = _.map(
					otherContests,
					_.bind(function (contest) {
						var other_cpu = this.get("master").getWhere(
							"contest_portal_users",
							{
								parent_contest_id: this.get("contest_id"),
							}
						);
						return {
							contest_id: contest.get("contest_id"),
							contest_name: contest.get("contest_name"),
							contest_portal_name:
								contest.get("contest_portal_name") ||
								contest.get("contest_short_name"),
							contest_short_name: contest.get("contest_short_name"),
							contest_hash: contest.get("contest_hash"),
							terms:
								(
									_.findWhere(contest.get("master").get("contest_terms"), {
										contest_id: contest.get("contest_id"),
									}) || {}
								).terms || {},
							portal_user: _.extend({}, (other_cpu || {}).attributes),
						};
					}, this)
				);
			}

			var show_leaderboard_unix_time = null;
			var contest_window_start_unix_time = null;

			if (Object.keys(output.window).length !== 0) {
				// get contest_window_start_at from the window if available, then convert to unix
				contest_window_start_unix_time = output.window.contest_window_start_at
					? moment
							.tz(output.window.contest_window_start_at, "America/New_York")
							.unix() * 1000
					: null;

				// get show_leaderboard_at from the window if available, then convert to unix
				show_leaderboard_unix_time = output.window.show_leaderboard_at
					? moment
							.tz(output.window.show_leaderboard_at, "America/New_York")
							.unix() * 1000
					: null;
			}

			// set default access to leaderboards as true
			output.leaderboards_can_access = true;

			// it's not time to show the leaderboard yet
			if (
				!show_leaderboard_unix_time ||
				show_leaderboard_unix_time - moment().valueOf() > 0
			) {
				output.leaderboards_can_access = false;
			}

			// Can't access old leaderboards - we've removed the display names.
			if (contest_window_start_unix_time < AoPS.bd.pii_removed_at) {
				output.leaderboards_can_access = false;
			}

			return output;
		},
		removeInvitedStudent: function (input) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			setTimeout(
				_.bind(function () {
					AoPS.Contests.Utils.ajax_portal_runner.run(
						"remove-invited-student",
						_.extend(
							{
								parent_contest_id:
									this.get("parent_contest_id") || this.get("contest_id"),
							},
							input
						),
						_.bind(function (ok, data) {
							AoPS.Ui.Modal.removeModal(loadingModal);
							if (ok) {
								this.get("master").addOrUpdateContestPortalInvitation(
									data.response.contest_portal_invitations || []
								);
								this.trigger("refresh");
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.html("Student successfully removed!")
								);
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.text("Error: " + data.error_msg)
								);
							}
						}, this)
					);
				}, this),
				500
			);
		},
		updateTeam: function (input) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			setTimeout(
				_.bind(function () {
					AoPS.Contests.Utils.ajax_portal_runner.run(
						"update-team",
						_.extend(
							{
								parent_contest_id:
									this.get("parent_contest_id") || this.get("contest_id"),
							},
							input
						),
						_.bind(function (ok, data) {
							AoPS.Ui.Modal.removeModal(loadingModal);
							if (ok) {
								this.get("master").addOrUpdateContestTeam([
									data.response.contest_team,
								]);
								this.trigger("refresh");
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.text("Error: " + data.error_msg)
								);
							}
						}, this)
					);
				}, this),
				500
			);
		},
		updateSpecialManageStudent: function (input) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			setTimeout(
				_.bind(function () {
					AoPS.Contests.Utils.ajax_portal_runner.run(
						input.action + "-special-manage-student",
						_.extend(
							{
								parent_contest_id:
									this.get("parent_contest_id") || this.get("contest_id"),
							},
							input
						),
						_.bind(function (ok, data) {
							AoPS.Ui.Modal.removeModal(loadingModal);
							if (ok) {
								this.get("master").addOrUpdateContestPortalUser(
									data.response.contest_portal_users || []
								);
								this.trigger("refresh");
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.text("Error: " + data.error_msg)
								);
							}
						}, this)
					);
				}, this),
				500
			);
		},
		updateInvitedStudent: function (input) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			setTimeout(
				_.bind(function () {
					AoPS.Contests.Utils.ajax_portal_runner.run(
						"update-invited-student",
						_.extend(
							{
								parent_contest_id:
									this.get("parent_contest_id") || this.get("contest_id"),
							},
							input
						),
						_.bind(function (ok, data) {
							AoPS.Ui.Modal.removeModal(loadingModal);
							if (ok) {
								this.get("master").addOrUpdateContestPortalInvitation(
									data.response.contest_portal_invitations || []
								);
								this.trigger("refresh");
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.text("Error: " + data.error_msg)
								);
							}
						}, this)
					);
				}, this),
				500
			);
		},
		updateInvitedStudentPassword: function (input) {
			var loadingModal = AoPS.Contests.Utils.CreateModalInescapable();
			setTimeout(
				_.bind(function () {
					AoPS.Contests.Utils.ajax_portal_runner.run(
						"update-invited-student-password",
						_.extend(
							{
								parent_contest_id:
									this.get("parent_contest_id") || this.get("contest_id"),
							},
							input
						),
						_.bind(function (ok, data) {
							AoPS.Ui.Modal.removeModal(loadingModal);
							if (ok) {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.html("Password successfully updated!")
								);
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />")
										.css("max-width", "480px")
										.text("Error: " + data.error_msg)
								);
							}
						}, this)
					);
				}, this),
				500
			);
		},
		validateAndUpdatePortalUserData: function (input, success, failure) {
			var cpu = this.computeContestPortalUser();
			var registered_at = cpu.get("registered_at");
			var registrationForm =
				_.findWhere(
					this.get("master").get("contest_portal_registration_forms") || [],
					{contest_id: this.get("contest_id")}
				) || {};
			var fields = _.reduce(
				_.pluck(
					AoPS.Contests.Utils.processRegistrationForm(
						registrationForm.form,
						input
					),
					"fields"
				),
				function (carry, item) {
					return carry.concat(item);
				},
				[]
			);
			var exported = this.export();

			var $issues = _.reduce(
				fields,
				_.bind(function ($ul, field) {
					if (!field.optional && !field.value) {
						$ul.append(
							$("<li />")
								.text(
									field.type === "select"
										? "Please select an option for "
										: "Please enter a value for "
								)
								.append($("<b />").text(field.name_short))
								.append(".")
						);
					} else if (field.value && field.value.length > field.max_length) {
						$ul.append(
							$("<li />")
								.text(
									"Please enter at most " +
										(field.max_length > 1
											? field.max_length + " characters"
											: " one character") +
										" for "
								)
								.append($("<b />").text(field.name_short))
								.append(".")
						);
					} else if (field.value && field.value.length < field.min_length) {
						$ul.append(
							$("<li />")
								.text(
									"Please enter at least " +
										(field.min_length > 1
											? field.min_length + " characters"
											: " one character") +
										" for "
								)
								.append($("<b />").text(field.name_short))
								.append(".")
						);
					} else if (field.value && field.validator) {
						if (
							_.isFunction(
								AoPS.Contests.Utils.formFieldValidators[field.validator]
							) &&
							!AoPS.Contests.Utils.formFieldValidators[field.validator](
								field.value
							)
						) {
							if (field.validation_error) {
								$ul.append($("<li />").html(field.validation_error));
							} else {
								$ul.append(
									$("<li />")
										.text("Please enter a valid ")
										.append($("<b />").text(field.name_short))
										.append(".")
								);
							}
						}
					}
					return $ul;
				}, this),
				$("<ul />")
			);

			var $verification = _.reduce(
				fields,
				_.bind(function ($ul, field) {
					if (!field.depends_on && (!field.optional || field.value)) {
						if (
							_.isFunction(
								AoPS.Contests.Utils.formFieldReplacers[field.replacer]
							)
						) {
							$ul.append(
								$("<li />")
									.text(field.name_short + ": ")
									.append(
										$("<b />").text(
											AoPS.Contests.Utils.formFieldReplacers[field.replacer](
												field.value
											)
										)
									)
							);
						} else {
							$ul.append(
								$("<li />")
									.text(field.name_short + ": ")
									.append($("<b />").text(field.display))
							);
						}
					}
					return $ul;
				}, this),
				$("<ul />")
			);

			if ($issues.html().length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							Handlebars.compile(
								exported.terms.registration_modal[
									!registered_at ? "register_error" : "edit_error"
								]
							)(exported)
						)
						.append($issues)
				);
			} else {
				AoPS.Contests.Utils.CreateModalConfirm(
					$("<div />")
						.css("max-width", "480px")
						.text(
							Handlebars.compile(
								exported.terms.registration_modal[
									!registered_at ? "register_confirm" : "edit_confirm"
								]
							)(exported)
						)
						.append($verification),
					_.bind(function () {
						this.updatePortalUserData(
							_.reduce(
								fields,
								_.bind(function (data, field) {
									if (
										_.isFunction(
											AoPS.Contests.Utils.formFieldReplacers[field.replacer]
										)
									) {
										data[field.key] = AoPS.Contests.Utils.formFieldReplacers[
											field.replacer
										](field.value);
									} else {
										data[field.key] = field.value;
									}
									return data;
								}, this),
								{}
							),
							success,
							failure
						);
					}, this),
					null,
					{
						confirm_button_ok:
							exported.terms.registration_modal[
								!registered_at ? "register_verb" : "edit_verb"
							].toUpperCase(),
						confirm_button_cancel: "CANCEL",
					}
				);
			}
		},
		updatePortalUserData: function (input, success, failure) {
			var cpu = this.computeContestPortalUser();
			AoPS.Contests.Utils.ajax_portal_runner.run(
				"update-portal-user-data",
				{
					portal_user_id: cpu.get("portal_user_id"),
					contest_id: cpu.get("contest_id"),
					user_id: cpu.get("user_id"),
					json_object_data: JSON.stringify(input),
				},
				_.bind(function (ok, data) {
					if (ok) {
						cpu.set(data.response.portal_user);
						if (_.isFunction(success)) {
							success();
						}
					} else {
						if (data.error_msg) {
							setTimeout(function () {
								AoPS.Contests.Utils.CreateModalAlert(
									$("<div />").css("max-width", "480px").text(data.error_msg)
								);
							}, 100);
						}
						if (_.isFunction(failure)) {
							failure();
						}
					}
				}, this)
			);
		},
		checkIfAnyWindowPropertiesAreTrue: function (props) {
			var window = this.computeWindow();
			if (window) {
				return _.reduce(
					props,
					function (carry, prop) {
						return carry || window.get(prop);
					},
					false
				);
			}
			return false;
		},
		hasStarted: function () {
			return this.checkIfAnyWindowPropertiesAreTrue([
				"official_individual_contest_has_started",
				"unofficial_individual_contest_has_started",
			]);
		},
		hasEnded: function () {
			return this.checkIfAnyWindowPropertiesAreTrue([
				"official_individual_contest_has_ended",
				"unofficial_individual_contest_has_ended",
			]);
		},
		isStudentPlayable: function () {
			return !(this.get("data") || {}).student_cannot_play;
		},
		isCurrentIndividual: function () {
			return this.checkIfAnyWindowPropertiesAreTrue([
				"official_individual_contest_is_current",
				"unofficial_individual_contest_is_current",
			]);
		},
		isCurrentTeam: function () {
			return this.checkIfAnyWindowPropertiesAreTrue([
				"official_team_contest_is_current",
				"unofficial_team_contest_is_current",
			]);
		},
		isCurrent: function () {
			return this.isCurrentIndividual() || this.isCurrentTeam();
		},
		isUpcomingIndividual: function () {
			var SPECIAL_UPCOMING = {
				// mathcounts-2020-2021-chapter-invitational
				14: {
					total_stagger_groups: 6,
					stagger_offset_ms: 120000, // 2 minutes
				},
				// mathcounts-2020-2021-state
				30: {
					total_stagger_groups: 3,
					stagger_offset_ms: 60000, // 1 minute
				},
				// aime-2020-2021-1
				32: {
					total_stagger_groups: 6,
					stagger_offset_ms: 60000, // 1 minute
				},
				// aime-2020-2021-2
				33: {
					total_stagger_groups: 6,
					stagger_offset_ms: 60000, // 1 minute
				},
				// mathcounts-2021-2022-state
				68: {
					total_stagger_groups: 6,
					stagger_offset_ms: 30000, // 30 seconds
				},
			};

			var is_upcoming = "official_individual_contest_is_upcoming";

			// If they're in the middle of it, don't be upcoming.
			if (this.isActiveIndividual()) {
				return false;
			}

			try {
				var contest_id = this.get("contest_id");
				if (contest_id && SPECIAL_UPCOMING.hasOwnProperty(contest_id)) {
					return this.isUpcomingIndividualSpecial(SPECIAL_UPCOMING[contest_id]);
				}

				return this.computeWindow().get(is_upcoming) ? true : false;
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		/**
		 * isUpcomingIndividual() but for staggered starts
		 *
		 * @param {object} options
		 * @param {number} options.total_stagger_groups Number of batches
		 * @param {number} options.stagger_offset_ms Number of milliseconds between each batch
		 * @returns {boolean}
		 */
		isUpcomingIndividualSpecial: function (options) {
			/**
			 * How soon to show the orange event countdown bar.
			 */
			var UPCOMING_BUFFER_MS = 1000 * 60 * 60 * 12; // 12 hours
			var start_time = this.getStartTimeIndividual();
			if (!start_time) {
				return false;
			}

			start_time = start_time.replace(/-/g, "/");
			if (moment().isDST()) {
				start_time += " EDT";
			} else {
				start_time += " EST";
			}

			var start_moment = moment(start_time);
			var host_id = this.get("master").get("host_id");
			var has_exceptions = this.computeWindow().get("has_exceptions");

			var {ms_until_official_start, ms_until_staggered_start} =
				AoPS.Contests.Utils.getStaggeredStartTime(
					_.extend(options, {
						start_moment,
						host_id,
					})
				);

			var ms_until_user_start = has_exceptions
				? ms_until_official_start
				: ms_until_staggered_start;

			return (
				ms_until_user_start > 0 && ms_until_user_start <= UPCOMING_BUFFER_MS
			);
		},
		isUpcomingTeam: function () {
			var is_upcoming = "official_team_contest_is_upcoming";

			// If they're in the middle of it, don't be upcoming.
			if (this.isActiveTeam()) {
				return false;
			}

			try {
				return this.computeWindow().get(is_upcoming) ? true : false;
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isUpcoming: function () {
			return this.isUpcomingIndividual() || this.isUpcomingTeam();
		},
		isRegisteredIndividual: function () {
			var registered_hashes_individual = this.get("master").get(
				"registered_hashes_individual"
			);
			try {
				return registered_hashes_individual.includes(this.get("contest_hash"));
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isRegisteredTeam: function () {
			var registered_hashes_team = this.get("master").get(
				"registered_hashes_team"
			);
			try {
				return registered_hashes_team.includes(this.get("contest_hash"));
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isCompletedIndividual: function () {
			var completed_hashes_individual = this.get("master").get(
				"completed_hashes_individual"
			);
			try {
				return Object.keys(completed_hashes_individual).includes(
					this.get("contest_hash")
				);
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isCompletedTeam: function () {
			var completed_hashes_team = this.get("master").get(
				"completed_hashes_team"
			);
			try {
				return Object.keys(completed_hashes_team).includes(
					this.get("contest_hash")
				);
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		hasTeamContest: function () {
			return this.getStartTimeTeam() ? true : false;
		},
		isCompleted: function () {
			return (
				this.isCompletedIndividual() &&
				(!this.hasTeamContest() || this.isCompletedTeam())
			);
		},
		isActiveIndividual: function () {
			var active_hashes_individual = this.get("master").get(
				"active_hashes_individual"
			);
			try {
				return Object.keys(active_hashes_individual).includes(
					this.get("contest_hash")
				);
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isActiveTeam: function () {
			var active_hashes_team = this.get("master").get("active_hashes_team");
			try {
				return Object.keys(active_hashes_team).includes(
					this.get("contest_hash")
				);
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isActive: function () {
			return (
				this.isActiveIndividual() ||
				(this.hasTeamContest() && this.isActiveTeam())
			);
		},
		getCompletionDateIndividual: function () {
			if (this.isCompletedIndividual()) {
				var completed_hashes_individual = this.get("master").get(
					"completed_hashes_individual"
				);
				try {
					return (
						moment(
							completed_hashes_individual[this.get("contest_hash")],
							"YYYY-MM-DD HH:mm:ss"
						).format("MM/DD/YYYY h:mma") + " ET"
					);
				} catch (e) {
					console.error(e);
				}
			}
			return null;
		},
		/**
		 * Returns all registered *non-practice* events,
		 * sorted by their contest window's closing datetime
		 */
		getRegisteredEvents: function () {
			var contests = this.get("master").get("contests");
			var registered_hashes_individual = this.get("master").get(
				"registered_hashes_individual"
			);
			var events = [];
			try {
				for (var hash of registered_hashes_individual) {
					var event = contests.findWhere({contest_hash: hash});
					if (event && !event.isPractice()) {
						events.push(event);
					}
				}
			} catch (e) {
				console.error(e);
			}

			// sort from latest close to earliest close
			events.sort((e1, e2) => {
				var w1 = e1.computeWindow().get("official_individual_contest_end_at");
				var w2 = e2.computeWindow().get("official_individual_contest_end_at");
				if (w1 < w2) {
					return 1;
				}
				if (w1 > w2) {
					return -1;
				}
				return 0;
			});

			return events;
		},
		getPreviousEvent: function () {
			try {
				var previous_hash = this.get("succeeds");
				if (previous_hash) {
					return this.get("master")
						.get("contests")
						.findWhere({contest_hash: previous_hash});
				}
			} catch (e) {
				console.error(e);
			}
			return null;
		},
		isPractice: function () {
			try {
				return this.get("contest_hash").includes("practice");
			} catch (e) {
				console.error(e);
			}
			return null;
		},
		getStartTimeIndividual: function () {
			var start_at = "official_individual_contest_start_at";
			try {
				return this.computeWindow().get(start_at);
			} catch (e) {
				console.error(e);
			}
			return null;
		},
		getStartTimeTeam: function () {
			var start_at = "official_team_contest_start_at";
			try {
				return this.computeWindow().get(start_at);
			} catch (e) {
				console.error(e);
			}
			return null;
		},
		/**
		 * Returns the corresponding button text for the contest
		 *
		 * Example outputs:
		 * Start ((Individual)|(Team))? (Contest)|(Competition)      <-- button text
		 * View ((Individual)|(Team))? Results                       <-- button text
		 * ((Individual)|(Team))? (Contest)|(Competition) Completed  <-- completed text
		 *
		 * @param {boolean} start True if start contest, False if view results
		 * @param {boolean} individual True if individual contest, False if team contest
		 * @param {integer} main_contest_id Contest ID of the parent contest
		 * @param {boolean} completed_text True for "completed" text, false for button text
		 * @returns {string} Text to use for button
		 */
		generateEventText: function (
			start,
			individual,
			main_contest_id,
			completed_text = false
		) {
			var contest = null;
			try {
				var contest_terms = this.get("master").get("contest_terms");
				var terms = _.findWhere(contest_terms, {contest_id: main_contest_id});
				if (terms) {
					contest = terms.terms.contest.uc;
				}
			} catch (e) {
				// do nothing
			}

			// default to "Contest" if can't find term JSON
			if (!contest) {
				contest = "Contest";
			}

			var text = [];
			var space = "&nbsp;";
			// if getting "completed" text:
			if (completed_text) {
				text = [contest, "Completed"];
				// if has team contest, also insert corresponding contest type
				if (this.hasTeamContest()) {
					text.splice(0, 0, individual ? "Individual" : "Team");
				}
				return text.join(space);
			}
			// if getting button text:
			// either start contest or view results
			text = start ? ["Start", contest] : ["View", "Results"];
			// if has team contest, also insert corresponding contest type
			if (this.hasTeamContest()) {
				text.splice(1, 0, individual ? "Individual" : "Team");
			}
			return text.join(space);
		},
		generateIndividualStartURL: function () {
			return "/contests/" + this.get("contest_hash") + "/individual";
		},
		generateTeamStartURL: function () {
			return "/contests/" + this.get("contest_hash") + "/team";
		},
		generateResultsURL: function () {
			return "/contests/" + this.get("contest_hash") + "/review";
		},
		generateDismissalKey: function (student_id) {
			if (!student_id) {
				return null;
			}
			var type = "";
			// countdown if upcoming & non-practice, button if current/completed
			if (!this.isPractice() && this.isUpcomingIndividual()) {
				type = "countdown";
			} else {
				type = this.isCompleted() ? "view_results" : "start_contest";
			}
			var key_attr = ["hide", student_id, this.get("contest_hash"), type];
			return key_attr.join("_");
		},
		isDismissedByUser: function (student_id) {
			try {
				var key = this.generateDismissalKey(student_id);
				// check local storage
				return window.localStorage.getItem(key) ? true : false;
			} catch (e) {
				console.error(e);
			}
			return false;
		},
		isDisplayable: function (student_id) {
			// If this is not a playable contest, immediately return false
			if (!this.isStudentPlayable()) {
				return false;
			}

			// if not registered at all, immediately return false
			if (!this.isRegisteredIndividual() && !this.isRegisteredTeam()) {
				return false;
			}

			/**
			 * If practice event, must be one of the following
			 * - current but not yet completed
			 * - completed and not already dismissed when results are out
			 */
			if (this.isPractice()) {
				return (
					(this.isCurrent() && !this.isCompleted()) ||
					(this.isActive() && !this.isCompleted()) ||
					(this.isCompleted() &&
						!this.isDismissedByUser(student_id) &&
						this.canViewResults())
				);
			}

			// Special academy logic. If the contest window is ended, show no banner
			if (this.get("is_academy")) {
				var window = this.computeWindow();

				if (window.get("contest_window_has_ended")) {
					return false;
				}
			}

			/**
			 * If not practice event, must be one of the following:
			 * - upcoming (within 24 hours)
			 * - current but not yet completed
			 * - completed and not already dismissed when results are out
			 */
			return (
				this.isUpcoming() ||
				(this.isCurrent() && !this.isCompleted()) ||
				(this.isActive() && !this.isCompleted()) ||
				(this.isCompleted() &&
					!this.isDismissedByUser(student_id) &&
					this.canViewResults())
			);
		},
		canViewResultsIndividual: function () {
			var window = this.computeWindow();
			var show_review_at = window.get("show_review_at");
			var show_review_currently = window.get("show_review_currently");
			return (
				show_review_at && show_review_currently && this.isCompletedIndividual()
			);
		},
		canViewResultsTeam: function () {
			var window = this.computeWindow();
			var show_review_at = window.get("show_review_at");
			var show_review_currently = window.get("show_review_currently");
			return show_review_at && show_review_currently && this.isCompletedTeam();
		},
		canViewResults: function (check_completed = false) {
			var window = this.computeWindow();
			var show_review_at = window.get("show_review_at");
			var show_review_currently = window.get("show_review_currently");
			return (
				show_review_at &&
				show_review_currently &&
				(!check_completed || this.isCompleted())
			);
		},
		isAMC: function () {
			return this.get("flavor_hash").indexOf("amc") === 0;
		},
		/**
		 * To add additional words that may vary from event to event
		 */
		generateAdditionalDetails: function () {
			// incomplete current official AMC contests only
			if (
				!this.isCompleted() &&
				this.isCurrent() &&
				this.isAMC() &&
				!this.isPractice()
			) {
				return $("<span />")
					.addClass("event-banner-details")
					.html(
						"Do not start this competition before the time designated by your Competition Manager."
					)
					.add("<br>")
					.add(
						$("<span />")
							.addClass("event-banner-sub-details")
							.html(
								"Clicking START COMPETITION will bring you to the pre-competition instructions. It will not begin the competition timer."
							)
					)
					.add("<br>");
			}
			return "";
		},
		/**
		 * Returns the correct events to display on the banner
		 * Null if no such events exist
		 *
		 * @param {object} student_id Student information
		 * @returns {object|null} event item
		 */
		chooseEventBannerToDisplay: function (student_id) {
			var events = this.getRegisteredEvents();
			if (events.length === 0) {
				return false;
			}
			var eventsToDisplay = [];
			for (var event of events) {
				// if registered event is upcoming (starts within 24 hours) or current and not dismissed, use for banner
				if (event.isDisplayable(student_id)) {
					eventsToDisplay.push(event);
				}
				var prev = event.getPreviousEvent();
				while (prev) {
					if (prev.isDisplayable(student_id)) {
						eventsToDisplay.push(prev);
					}
					prev = prev.getPreviousEvent();
				}
			}

			return eventsToDisplay.length ? eventsToDisplay : null;
		},
		/**
		 * Add an event bar to the student portal if it hasn't already
		 * been hidden by the student
		 *
		 * @param {number} student_id Student information
		 * @param {number} main_contest_id ID of the main contest
		 * @returns {object|null} event item with key or false
		 */
		addEventBanners: function (student_id, main_contest_id) {
			var events = this.chooseEventBannerToDisplay(student_id);
			if (!events) {
				return null;
			}
			var banners = [];
			for (var event of events) {
				var banner = this.generateEventBanner(
					event,
					student_id,
					main_contest_id
				);
				if (banner) {
					banners.push(banner);
				}
			}
			return banners.length ? banners : null;
		},
		generateEventBanner: function (event, student_id, main_contest_id) {
			var upcoming = event.isUpcomingIndividual();
			var practice = event.isPractice();
			var start_time = event.getStartTimeIndividual();
			var has_exceptions = event.computeWindow().get("has_exceptions");
			var key = event.generateDismissalKey(student_id);
			var $banner_main = $("<div />").addClass("event-banner-text");

			// If the team contest happens before individual contest and it's not been completed...
			if (
				event.hasTeamContest() &&
				(event.isCurrentTeam() || event.isUpcomingTeam()) &&
				event.getStartTimeTeam() < event.getStartTimeIndividual() &&
				!event.isCompletedTeam()
			) {
				upcoming = event.isUpcomingTeam();
				start_time = event.getStartTimeTeam();
			}

			var $event_banner_text = $("<span />");

			if (event.get("is_academy") && event.isCompleted()) {
				$event_banner_text.text(event.get("contest_name") + " has closed!");
			} else if (upcoming) {
				$event_banner_text.text(event.get("contest_name") + " will open in:");
			} else {
				$event_banner_text.text(event.get("contest_name") + " is open!");
				$event_banner_text.append($("<br>"));
			}

			$banner_main.append($event_banner_text);

			// countdown if upcoming, button if current/completed
			var $banner_secondary;
			if (!practice && upcoming) {
				$banner_secondary = $("<span />")
					.addClass("event-banner-countdown")
					.attr("data-countdown-time", start_time)
					.attr("data-has-exceptions", has_exceptions)
					.add($("<br>"));
			} else {
				$banner_secondary = $("<span />").addClass("event-banner-buttons");
				var $buttons = [];
				if (event.isCompletedIndividual()) {
					if (event.canViewResultsIndividual()) {
						$buttons.push(
							$("<a />")
								.attr("href", event.generateResultsURL())
								.html(event.generateEventText(false, true, main_contest_id))
						);
					}
				} else if (event.isCurrentIndividual() || event.isActiveIndividual()) {
					$buttons.push(
						$("<a />")
							.attr("href", event.generateIndividualStartURL())
							.html(event.generateEventText(true, true, main_contest_id))
					);
				}

				if (event.isCompletedTeam()) {
					if (event.canViewResultsTeam()) {
						$buttons.push(
							$("<a />")
								.attr("href", event.generateResultsURL() + "#team")
								.html(event.generateEventText(false, false, main_contest_id))
						);
					}
				} else if (
					event.hasTeamContest() &&
					event.isRegisteredTeam() &&
					(event.isCurrentTeam() || event.isActiveTeam())
				) {
					$buttons.push(
						$("<a />")
							.attr("href", event.generateTeamStartURL())
							.html(event.generateEventText(true, false, main_contest_id))
					);
				}

				// if no buttons to show, don't display an event banner
				if ($buttons.length === 0) {
					return null;
				}
				for (var $button of $buttons) {
					$banner_secondary.append($button);
				}
			}
			var $banner_details = event.generateAdditionalDetails();

			var $banner = $banner_main
				.append($banner_secondary)
				.append($banner_details);

			return {
				banner: $banner,
				event: event,
				key: key,
				is_practice: practice,
			};
		},
		getContestModelByHash: function (hash) {
			var contests = this.get("master").get("contests");
			return contests.findWhere({contest_hash: hash});
		},
	});

	return Models;
})(AoPS.Contests.Models);
